import React from "react";

type Props = {
  message?: string;
};

const AccessDenied = ({ message }: Props) => (
  <div className="flex items-center justify-center py-20">
    <div className="text-center">
      <h2 className="text-xl font-semibold text-gray-700 mb-2">ઍક્સેસ નકારી</h2>
      <p className="text-gray-500">
        {message || "તમને આ પેજ જોવાની પરવાનગી નથી."}
      </p>
    </div>
  </div>
);

export default AccessDenied;
